import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async save({ commit, state }, { user_id }) {
            const { data } = await axios.post(`/admin/users/${user_id}/sites`, state.entity);
            return data;
        },
        async delete({ commit }, { user_id, id }) {
            await axios.delete(`/admin/users/${user_id}/sites/${ id }`);
        },
    },

    getters: {}
}
